<template>
  <div v-if="section">
    <h1 class="text-center" v-text="section.title"></h1>
    <v-row>
      <p v-html="section.desc"></p>
    </v-row>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="12"
      v-for="(block, index) in section.blocks"
      :key="index"
    >
      <v-row v-if="block && block.images && block.images.length > 0">
        <carousel-image :slides="getImageUrls(block.images)" />
      </v-row>
      <h2 v-text="block.title"></h2>

      <v-row>
        <p v-html="block.content"></p>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import CarouselImage from "@/views/home/page/CarouselImage.vue";

@Component({
  name: "TopImage",
  components: { CarouselImage },
  props: {
    section: {
      default: null,
    },
  },
})
export default class TopImage extends Vue {
  images = [];
  getImageUrls(images) {
    const urls = [];
    if (images && images.length > 0) {
      for (let i = 0; i < images.length; i++) {
        if (images[i] && images[i].url) {
          urls.push(images[i].url);
        }
      }
    }
    return urls;
  }
}
</script>
